import { useEffect } from 'react';
import { useLoading } from '../context/LoadingContext';

/**
 * Hook utilitaire pour gérer l'état de chargement d'une page
 * 
 * @param isLoading - État de chargement local de la page
 * @param dependencies - Dépendances pour déclencher le changement d'état (optionnel)
 */
export function usePageLoading(isLoading: boolean, dependencies: any[] = []) {
  const { setPageLoading } = useLoading();
  
  useEffect(() => {
    // Définir l'état de chargement global basé sur l'état local
    setPageLoading(isLoading);
    
    // Assurer que le footer est affiché lorsque le composant est démonté
    return () => {
      setPageLoading(false);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, setPageLoading, ...dependencies]);
}
